
import { COMPANY_NAME, COMPANY_DOMAIN, CONTACT_EMAIL, COMPANY_ADDRESS} from '../config';
import { useTranslation } from 'react-i18next';

const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl px-6 my-20">
      <div className="text-left">
        <h1>Terms and Conditions</h1>
        <h2 className="mt-8">Terms of Use for {COMPANY_NAME}</h2>
        <p>Welcome to {COMPANY_NAME}. By accessing or using our platform at {COMPANY_DOMAIN}, you agree to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern {COMPANY_NAME}'s relationship with you in relation to this platform.</p>

        <h2 className="mt-8">Use of the Platform</h2>
        <p>The content of this platform is for your general information and use only. It is subject to change without notice. Your use of any information or materials on this platform is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through this platform meet your specific requirements.</p>

        <h2 className="mt-8">Intellectual Property</h2>
        <p>This platform contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited except in accordance with the copyright notice, which forms part of these terms and conditions.</p>

        <h2 className="mt-8">Prohibited Activities</h2>
        <p>When using this platform, you agree to comply with all applicable laws and regulations. You may not use this platform to engage in any illegal or unauthorized activities, including, but not limited to:</p>
        <ul className="list-disc ml-5">
          <li>Infringing the intellectual property rights of others</li>
          <li>Posting or transmitting harmful, obscene, or defamatory material</li>
          <li>Engaging in fraudulent activity</li>
          <li>Attempting to gain unauthorized access to the platform or related systems</li>
        </ul>

        <h2 className="mt-8">Limitation of Liability</h2>
        <p>In no event will {COMPANY_NAME} be liable for any indirect, special, incidental, punitive, or consequential damages, including, but not limited to, loss of revenue, loss of profits, or loss of data arising out of or in connection with the use of the platform.</p>

        <h2 className="mt-8">Termination</h2>
        <p>We reserve the right to terminate or suspend your access to our platform without notice and at our sole discretion if you violate these Terms of Use or engage in any conduct that we deem harmful to the platform or other users.</p>

        <h2 className="mt-8">Governing Law</h2>
        <p>These Terms of Use shall be governed by and construed in accordance with the laws of Ukraine. Any disputes relating to these Terms of Use will be subject to the exclusive jurisdiction of the courts of Ukraine.</p>

        <h2 className="mt-8">Changes to the Terms</h2>
        <p>We may revise these Terms of Use from time to time. Any changes will be posted on this page, and your continued use of the platform after such changes have been made will constitute your acceptance of the new terms.</p>

        <h2 className="mt-8">Operator of the Platform</h2>
        <p>The platform crino.io is owned and operated by Sole Proprietor Anton Liakhovskii (registration number: 3298210978), registered at:<br></br>  
        {COMPANY_ADDRESS}.</p>
        <h2 className="mt-8">Contact Us</h2>
        <p>If you have any questions about these Terms of Use, please contact us at:</p>
        <p>Email: {CONTACT_EMAIL}</p>
      </div>
    </div>
  );
};

export default TermsOfUse;
